import React from 'react';

const students = [
  {
    name: '杨雷',
    level: '博士研究生',
    year: '2019级',
    research: '研究方向：全球碳配额分配及能源转型',
    email: 'lei-yang18@mails.tsinghua.edu.cn'
  },
  {
    name: '唐昊天',
    level: '博士研究生', 
    year: '2020级',
    research: '研究方向：氢能及CCUS利用及布局',
    email: 'tht20@mails.tsinghua.edu.cn'
  },
  {
    name: '张乾志',
    level: '博士研究生',
    year: '2021级',
    research: '研究方向：全球氢能贸易',
    email: 'zgz21@mails.tsinghua.edu.cn'
  },
  {
    name: '任晋辉',
    level: '博士研究生',
    year: '2022级', 
    research: '研究方向：分省电力脱碳路径',
    email: 'rjh22@mails.tsinghua.edu.cn'
  },
  {
    name: '丁琪',
    level: '博士研究生',
    year: '2023级',
    research: '研究方向：交通能源系统分析',
    email: 'dingq23@mails.tsinghua.edu.cn'
  },
  {
    name: '吕晋宁',
    level: '博士研究生',
    year: '2024级',
    research: '研究方向：能源系统分析',
    email: 'ljn24@mails.tsinghua.edu.cn'
  }
];

export default function Students() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">在读学生</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
          
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:mt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {students.map((student) => (
            <article key={student.name} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-x-4 text-xs">
                  <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                    {student.year}
                  </span>
                  <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                    {student.level}
                  </span>
                </div>
                <div className="group relative">
                  <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900">
                    {student.name}
                  </h3>
                  <p className="mt-5 text-sm leading-6 text-gray-600">{student.research}</p>
                </div>
                <div className="mt-4 flex items-center gap-x-4">
                  <div className="text-sm leading-6">
                    <p className="text-gray-600">
                      <a href={`mailto:${student.email}`} className="text-blue-600 hover:text-blue-500">
                        {student.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}